import { useMutation, useQueryClient, } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import postTransitionProposalHolding from "../requests/postTransitionPropsalHolding";
import { getTransitionProposalAnalysisSummaryKeyMaker } from "./useGetTransitionProposalAnalysisSummary";
import { getTransitionProposalBreakdownKeyMaker } from "./useGetTransitionProposalBreakdown";
import { getTransitionProposalHoldingsKeyMaker } from "./useGetTransitionProposalHoldings";
const IDEMPOTENCY_DESCRIPTOR = "post-transition-proposal";
const usePostTransitionProposalHolding = (config, transitionProposalId) => {
    const queryClient = useQueryClient();
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
    const mutation = useMutation({
        mutationFn: async ({ body }) => {
            if (config === null) {
                throw new Error("no auth");
            }
            return postTransitionProposalHolding(body, transitionProposalId, idempotencyKey, config);
        },
        onSuccess: (_, { transitionProposalId }) => {
            queryClient.invalidateQueries({
                queryKey: getTransitionProposalHoldingsKeyMaker(transitionProposalId, null),
            });
            queryClient.invalidateQueries({
                queryKey: getTransitionProposalAnalysisSummaryKeyMaker(transitionProposalId),
            });
            queryClient.invalidateQueries({
                queryKey: getTransitionProposalBreakdownKeyMaker(transitionProposalId),
            });
        },
        onSettled: () => {
            setIdempotencyKey(genIdempotencyKey(IDEMPOTENCY_DESCRIPTOR));
        },
    });
    return mutation;
};
export default usePostTransitionProposalHolding;
//# sourceMappingURL=usePostTransitionProposalHolding.js.map